// import modular routes
import { lazy } from "react";
import signInTemplateRoutes from "./signInTemplate";
import AffiliateTemplateRoutes from "./AffiliateTemplate";
import Home from "./Home";
import DistrictRoutes from "./District";
import StateRoutes from "./State";
import SubDistrictRoutes from "./SubDistrict";
import VillageRoutes from "./Village";
import BankRoutes from "./Bank";
import BranchRoutes from "./Branch";
import CategoryRoutes from "./Category";
import SubCategoryRoutes from "./SubCategory";
import OrganizationTypeRoutes from "./OrganizationType";
import SellerTemplateRoutes from "./SellerTemplate";
import ProfileSetting from "./Profile";
import LegalEntity from "./LegalEntity";
import ProductRoutes from "./Product";
import ProductVariantRoutes from "./ProductVariant";
import SellerProductVariantRoutes from "./SellerProductVariant";
import CustomerTemplateRoutes from "./CustomerTemplate";
import HubTemplateRoutes from "./Hub";
import BlockTemplateRoutes from "./Block";
import PinCodeTemplateRoutes from "./PinCode";
import FulfillmentcenterRoutes from "./Fulfillmentcenter";
import OrdersRoutes from "./Orders";
import Fulfill from "./Fulfill";
import Shipper from "./Shipper";
import Reports from "./Reports";
import UserRole from "./UserAccess/UserRole";
import AccessProfile from "./UserAccess/AccessProfile";
import PageCreation from "./UserAccess/PageCreation";
import PageMapping from "./UserAccess/PageMapping";
import Errors from "./Error";
import RoleActionMapping from "./UserAccess/RoleActionMapping";
import PageAccessProfileMapping from "./UserAccess/PageAccessProfileMapping";
import RoleAccessProfileMapping from "./UserAccess/RoleAccessProfileMapping";
import UserProfile from "./UserAccess/UserProfile";
import UserGroup from "./UserAccess/UserGroup";
import ComboProducts from "./ComboProducts";
import DeliveryPointRoutes from "./DeliveryPoint";
import FinancePage from "./FinancePage";
import SalesCommissionVoucher from "./FinancePage";
import ReconciliationLedger from "./FinancePage";
import SettingsPage from "./Profile";
import BlockVillageMappingPage from "./BlockVillageMapping";
import FutureFulfillment from "./FutureFulfillment";
import ProductActivation from "./ProductVariant";
import OffPlatformOrders from "./Orders";
import InstantOffSystemOrder from "./Orders";
import ResetPassword from "./signInTemplate";
import ChangePassword from "./ChangePassword";
import Organization from "./SaasRoutes/Organization";
import BrandPage from "./SaasRoutes/BrandPage";
import Application from "./SaasRoutes/Application";
import OrgAppMapRoutes from "./SaasRoutes/OrganizationAppMapRoute";
import Module from "./ModuleRoutes/Module";
import SubModule from "./ModuleRoutes/SubModule";
import Pages from "./ModuleRoutes/Pages";
import SubPages from "./ModuleRoutes/SubPages";
import ModuleOrgMapping from "./ModuleRoutes/ModuleOrgMapping";
import SubModuleOrgMapping from "./ModuleRoutes/SubModuleOrgMapping";
import PageOrgMapping from "./ModuleRoutes/PageOrgMapping";
import SubPageOrgMapping from "./ModuleRoutes/SubPageOrgMapping";
import Dashboard from "./SaasRoutes/Dashboard";
import CountryRoutes from "./Country";
import AuditLogsRoute from "./AuditLogs";
import CategoryLocationMappingRoutes from "./CategoryLocationMapping";
import SubCategoryLocationMappingRoutes from "./SubCategoryLocationMapping";
import SettingsLocationsRoutes from "./SettingsRoutes/Locations";
import SettingsSubscriptionRoutes from "./SettingsRoutes/Subscription";
import SettingsPersonalizationRoutes from "./SettingsRoutes/Personalization";
import SettingsBanksRoutes from "./SettingsRoutes/Banks";
import SettingsNodalPointsRoutes from "./SettingsRoutes/NodalPoints";
import SettingsPaymentGatewaysRoutes from "./SettingsRoutes/PaymentGateways";
import SettingsProductCategoriesRoutes from "./SettingsRoutes/ProductCategories";
import SettingsEntitiesRoutes from "./SettingsRoutes/Entities";
import SettingsOrganisationRoutes from "./SettingsRoutes/Organisation";
import SettingsUsersRoutes from "./SettingsRoutes/Users";
import SettingsRolesRoutes from "./SettingsRoutes/Roles";
import SettingsAccessProfilesRoutes from "./SettingsRoutes/AccessProfiles";
import SettingsApplicationsModulesRoutes from "./SettingsRoutes/ApplicationsModules";

const AccessDenied = lazy(() => import("../pages/common/AccessDenied"));

export default [
  { path: "/access-denied", noLayout: true, element: AccessDenied },
  ...Home,
  ...Reports,
  ...Fulfill,
  ...AffiliateTemplateRoutes,
  ...signInTemplateRoutes,
  ...DistrictRoutes,
  ...StateRoutes,
  ...SubDistrictRoutes,
  ...VillageRoutes,
  ...BankRoutes,
  ...BranchRoutes,
  ...CategoryRoutes,
  ...SubCategoryRoutes,
  ...OrganizationTypeRoutes,
  ...SellerTemplateRoutes,
  ...ProfileSetting,
  ...LegalEntity,
  ...ProductRoutes,
  ...ProductVariantRoutes,
  ...SellerProductVariantRoutes,
  ...CustomerTemplateRoutes,
  ...HubTemplateRoutes,
  ...BlockTemplateRoutes,
  ...PinCodeTemplateRoutes,
  ...FulfillmentcenterRoutes,
  ...OrdersRoutes,
  ...Shipper,
  ...Errors,
  ...UserRole,
  ...AccessProfile,
  ...PageCreation,
  ...PageMapping,
  ...RoleActionMapping,
  ...PageAccessProfileMapping,
  ...RoleAccessProfileMapping,
  ...UserProfile,
  ...ComboProducts,
  ...DeliveryPointRoutes,
  ...FinancePage,
  ...SalesCommissionVoucher,
  ...SettingsPage,
  ...BlockVillageMappingPage,
  ...FutureFulfillment,
  ...ProductActivation,
  ...OffPlatformOrders,
  ...InstantOffSystemOrder,
  ...ReconciliationLedger,
  ...BrandPage,
  ...ResetPassword,
  ...ChangePassword,
  ...Organization,
  ...Application,
  ...OrgAppMapRoutes,
  ...Module,
  ...SubModule,
  ...Pages,
  ...SubPages,
  ...ModuleOrgMapping,
  ...SubModuleOrgMapping,
  ...PageOrgMapping,
  ...SubPageOrgMapping,
  ...Dashboard,
  ...CountryRoutes,
  ...AuditLogsRoute,
  ...CategoryLocationMappingRoutes,
  ...SubCategoryLocationMappingRoutes,
  ...UserGroup,
  ...SettingsLocationsRoutes,
  ...SettingsSubscriptionRoutes,
  ...SettingsPersonalizationRoutes,
  ...SettingsBanksRoutes,
  ...SettingsNodalPointsRoutes,
  ...SettingsPaymentGatewaysRoutes,
  ...SettingsProductCategoriesRoutes,
  ...SettingsEntitiesRoutes,
  ...SettingsOrganisationRoutes,
  ...SettingsUsersRoutes,
  ...SettingsRolesRoutes,
  ...SettingsAccessProfilesRoutes,
  ...SettingsApplicationsModulesRoutes,
];
